/* AYO product page (sections/ayo-main-product.liquid): options, price, discount, installments,
   size guide, add to bag, Buy it now guard, bottom bar, "Added" sheet, gallery dots and tabs. */
(function () {
  if (customElements.get('ayo-product')) return;

  const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));

  const moneyFmt = (cents, format) => {
    const fmt = (n, dec, th, ds) => {
      const [i, d] = (n / 100).toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    return String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  };

  class AyoProduct extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-ayo-pdp-data]');
      if (!raw) return;
      this.d = JSON.parse(raw.textContent);
      this.t = this.d.text || {};
      this.sizeIdx = parseInt(this.dataset.sizeIndex, 10);
      this.colorIdx = parseInt(this.dataset.colorIndex, 10);
      this.low = parseInt(this.dataset.low, 10) || 0;
      this.form = this.querySelector('[data-ayo-pdp-form]');
      this.idInput = this.querySelector('[data-ayo-pdp-id]');
      this.addBtn = this.querySelector('[data-ayo-pdp-add]');
      this.hint = this.querySelector('[data-ayo-pdp-hint]');
      this.hintDefault = this.hint ? this.hint.textContent : '';
      this.msg = this.querySelector('[data-ayo-pdp-msg]');
      this.buyNow = this.querySelector('[data-ayo-pdp-buynow]');
      this.bar = this.querySelector('[data-ayo-pdp-bar]');
      this.guide = this.querySelector('[data-ayo-pdp-guide]');
      this.added = this.querySelector('[data-ayo-pdp-added]');
      this.lens = {};
      this.querySelectorAll('[data-ayo-pdp-guide-size]').forEach((c) => { this.lens[c.dataset.ayoPdpGuideSize] = c.dataset.len; });
      this.inBag = false;

      const cur = this.d.variants.find((v) => String(v.id) === String(this.idInput && this.idInput.value)) || this.d.variants[0];
      this.sel = cur ? cur.options.slice() : [];
      if (this.d.sizeOpen && this.sizeIdx >= 0) this.sel[this.sizeIdx] = null;

      this.addEventListener('click', (e) => this.onClick(e));
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(this.addBtn); });
      this.setupGallery();
      this.setupBar();
      this.querySelectorAll('dialog').forEach((dlg) => {
        dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('close', () => document.documentElement.classList.remove('ayo-lock'));
      });
      this.update(false);
    }

    disconnectedCallback() {
      if (this.onScroll) { window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); }
      document.body.classList.remove('modal__sticky-cart');
    }

    onClick(e) {
      const opt = e.target.closest('[data-ayo-pdp-opt]');
      if (opt) { this.choose(parseInt(opt.dataset.ayoPdpOpt, 10), opt.dataset.value); return; }
      if (e.target.closest('[data-ayo-pdp-guide-open]')) { this.openDialog(this.guide); return; }
      const cell = e.target.closest('[data-ayo-pdp-guide-size]');
      if (cell) {
        if (cell.classList.contains('is-out')) return;
        this.choose(this.sizeIdx, cell.dataset.ayoPdpGuideSize);
        this.guide.close();
        return;
      }
      if (e.target.closest('[data-ayo-pdp-close]')) { const dlg = e.target.closest('dialog'); if (dlg) dlg.close(); return; }
      if (e.target.closest('[data-ayo-pdp-guard]')) { this.warn(); return; }
      const wa = e.target.closest('[data-ayo-pdp-wa]');
      if (wa && !this.variant()) { e.preventDefault(); e.stopPropagation(); this.warn(); return; }
      const m = e.target.closest('[data-ayo-pdp-months]');
      if (m) {
        m.parentElement.querySelectorAll('[data-ayo-pdp-months]').forEach((b) => { const on = b === m; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        return;
      }
      const tab = e.target.closest('.ayo-pdp__tab');
      if (tab) { this.showTab(tab); return; }
      if (e.target.closest('[data-ayo-pdp-bar-btn]')) { this.barTap(); return; }
      const up = e.target.closest('[data-ayo-up-add]');
      if (up) { this.quickAdd(up); }
    }

    /* ---------- options ---------- */
    choose(i, value) {
      if (i < 0) return;
      this.sel[i] = value;
      // a color change keeps the size only if that size exists in the new color
      if (i !== this.sizeIdx && this.sizeIdx >= 0 && this.sel[this.sizeIdx] != null) {
        const ok = this.d.variants.some((v) => v.available && v.options.every((o, k) => this.sel[k] == null || o === this.sel[k]));
        if (!ok) this.sel[this.sizeIdx] = null;
      }
      this.classList.remove('is-warn');
      this.inBag = false;
      this.update(true);
      if (i === this.colorIdx) this.showColorMedia(value);
    }

    variant() {
      if (this.sel.some((x) => x == null)) return null;
      return this.d.variants.find((v) => v.options.every((o, k) => o === this.sel[k])) || null;
    }

    reference() {
      // the variant to show price and stock for while a size is still open
      return this.variant() || this.d.variants.find((v) => v.options.every((o, k) => this.sel[k] == null || o === this.sel[k])) || this.d.variants[0];
    }

    update(fromUser) {
      const v = this.variant();
      const ref = this.reference();
      // option buttons: selected state and what is still in stock with the other choices
      this.querySelectorAll('[data-ayo-pdp-opt]').forEach((b) => {
        const i = parseInt(b.dataset.ayoPdpOpt, 10);
        const on = this.sel[i] === b.dataset.value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        const avail = this.d.variants.some((x) => x.available && x.options[i] === b.dataset.value && x.options.every((o, k) => k === i || k === this.sizeIdx || this.sel[k] == null || o === this.sel[k]));
        b.classList.toggle('is-out', !avail);
      });
      if (this.guide && this.sizeIdx >= 0) {
        this.guide.querySelectorAll('[data-ayo-pdp-guide-size]').forEach((c) => {
          const z = c.dataset.ayoPdpGuideSize;
          const avail = this.d.variants.some((x) => x.available && x.options[this.sizeIdx] === z && x.options.every((o, k) => k === this.sizeIdx || this.sel[k] == null || o === this.sel[k]));
          c.classList.toggle('is-out', !avail);
          c.classList.toggle('is-on', this.sel[this.sizeIdx] === z);
        });
      }
      const cname = this.querySelector('[data-ayo-pdp-color-name]');
      if (cname && this.colorIdx >= 0) cname.textContent = this.sel[this.colorIdx] || '';

      this.paintPrice(ref);
      if (v && this.idInput) {
        this.idInput.value = v.id;
        if (fromUser) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      this.paintButtons(v);
      this.paintHint(v);
      this.paintBar(v, ref);
    }

    paintPrice(ref) {
      const M = (c) => moneyFmt(c, this.d.money);
      const price = ref.price;
      const cmp = ref.compare > price ? ref.compare : 0;
      const off = cmp ? Math.floor(((cmp - price) * 100) / cmp) : 0;
      const p = this.querySelector('[data-ayo-pdp-price]');
      if (p) p.textContent = M(price);
      const c = this.querySelector('[data-ayo-pdp-compare]');
      if (c) { c.hidden = !cmp; if (cmp) c.textContent = M(cmp); }
      const row = this.querySelector('[data-ayo-pdp-price-row]');
      if (row) row.classList.toggle('is-sale', !!cmp);
      const badge = this.querySelector('[data-ayo-pdp-badge]');
      const short = (c) => M(c).replace(/[.,]00(?=\D*$)/, '');
      if (badge) { badge.hidden = !cmp; badge.textContent = badge.dataset.showAs === 'amount' ? `-${short(cmp - price)}` : `-${off}%`; }
      const deal = this.querySelector('[data-ayo-pdp-deal]');
      if (deal) {
        deal.hidden = !cmp;
        if (cmp) {
          const map = { amount: M(cmp - price), percent: off, was: M(cmp), now: M(price), off: deal.dataset.showAs === 'amount' ? short(cmp - price) : `${off}%` };
          const tt = deal.querySelector('[data-ayo-pdp-deal-title]'); if (tt) tt.textContent = fill(deal.dataset.title, map);
          const tx = deal.querySelector('[data-ayo-pdp-deal-text]'); if (tx) tx.textContent = fill(deal.dataset.text, map);
          const bd = deal.querySelector('[data-ayo-pdp-deal-badge]'); if (bd) bd.textContent = fill(deal.dataset.badge, map);
        }
      }
      const inst = this.querySelector('[data-ayo-pdp-inst]');
      if (inst) {
        let longest = 1;
        inst.querySelectorAll('[data-ayo-pdp-per]').forEach((s) => {
          const n = parseInt(s.dataset.ayoPdpPer, 10) || 1;
          longest = Math.max(longest, n);
          s.textContent = fill(s.dataset.tpl, { monthly: M(Math.floor(price / n)) });
        });
        const line = inst.querySelector('[data-ayo-pdp-inst-line]');
        if (line) line.textContent = fill(inst.dataset.line, { monthly: M(Math.floor(price / longest)), months: longest });
      }
    }

    paintButtons(v) {
      if (!this.addBtn) return;
      const need = !v;
      const sold = v && !v.available;
      this.addBtn.toggleAttribute('data-need', need);
      this.addBtn.disabled = !!sold;
      this.addBtn.classList.remove('is-added');
      if (sold) this.addBtn.textContent = this.t.soldOut;
      else if (need) this.addBtn.textContent = this.t.pick;
      else if (this.sizeIdx >= 0) this.addBtn.textContent = fill(this.t.addSize, { size: this.sel[this.sizeIdx] });
      else this.addBtn.textContent = this.t.add;
      if (this.buyNow) this.buyNow.classList.toggle('is-locked', need || !!sold);
      this.paintWa(v);
    }

    paintWa(v) {
      const a = this.querySelector('[data-ayo-pdp-wa]');
      if (!a) return;
      a.classList.toggle('is-locked', !v);
      const ref = v || this.reference();
      const opts = v ? this.d.options.map((n, i) => `${n}: ${v.options[i]}`).filter((x) => !/Default Title/.test(x)).join(' · ') : '';
      const url = v ? `${a.dataset.url}?variant=${v.id}` : a.dataset.url;
      const msg = fill(a.dataset.msg, { title: a.dataset.title, options: opts, price: moneyFmt(ref.price, this.d.money), url }).replace(/\n{2,}/g, '\n').trim();
      a.href = `https://wa.me/${a.dataset.number}?text=${encodeURIComponent(msg)}`;
    }

    paintHint(v) {
      if (!this.hint) return;
      this.hint.classList.remove('is-warn', 'is-low');
      const size = this.sizeIdx >= 0 ? this.sel[this.sizeIdx] : null;
      if (!size) { this.hint.textContent = this.hintDefault; return; }
      const len = this.lens[size];
      if (v && v.qty != null && this.low > 0 && v.qty > 0 && v.qty <= this.low) {
        this.hint.textContent = fill(this.t.low, { count: v.qty, size, length: len || '' });
        this.hint.classList.add('is-low');
      } else if (len) {
        this.hint.textContent = fill(this.t.fit, { size, length: len });
      } else {
        this.hint.textContent = fill(this.t.picked, { size });
      }
    }

    warn() {
      this.classList.add('is-warn');
      if (this.hint) { this.hint.textContent = this.t.warn; this.hint.classList.add('is-warn'); }
      const box = this.querySelector('.ayo-pdp__box');
      if (box) {
        const r = box.getBoundingClientRect();
        if (r.top < 60 || r.bottom > window.innerHeight) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    /* ---------- add to bag ---------- */
    async add(btn) {
      const v = this.variant();
      if (!v) { this.warn(); return; }
      if (!v.available || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      if (this.msg) this.msg.hidden = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const fd = new FormData(this.form);
      fd.set('id', v.id);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((x) => x.id));
        fd.append('sections_url', window.location.pathname);
      }
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message || '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-product', productVariantId: v.id, cartData: data });
        }
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        this.inBag = true;
        if (this.addBtn) { this.addBtn.classList.add('is-added'); this.addBtn.textContent = this.t.added; }
        this.paintBar(v, v);
        const mode = this.dataset.afterAdd;
        if (mode === 'drawer' && cart && typeof cart.renderContents === 'function' && data.sections) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          this.refreshCart(cart, data);
          if (mode === 'sheet' && this.added) this.showAdded(v);
        }
      } catch (err) {
        if (this.msg) { this.msg.textContent = err.message || this.t.error; this.msg.hidden = false; }
      } finally {
        btn.classList.remove('is-loading');
      }
    }

    refreshCart(cart, data) {
      // update the drawer and bag count without opening the drawer
      if (!cart || !data.sections || typeof cart.getSectionsToRender !== 'function') return;
      const inner = cart.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      cart.classList.remove('is-empty');
      cart.getSectionsToRender().forEach((sec) => {
        const html = data.sections[sec.id];
        if (!html) return;
        const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
        if (!el) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector(sec.selector || '.shopify-section');
        if (src) el.innerHTML = src.innerHTML;
      });
    }

    async showAdded(v) {
      const sub = this.added.querySelector('[data-ayo-pdp-added-sub]');
      if (sub) sub.textContent = [this.querySelector('.ayo-pdp__title') ? this.querySelector('.ayo-pdp__title').textContent : '', ...v.options.filter((o) => o && o !== 'Default Title')].join(' · ');
      const img = this.added.querySelector('.ayo-pdp__added-img img');
      const slide = v.media && this.querySelector(`[data-media-id="${v.media}"] img`);
      if (img && slide) img.src = slide.currentSrc || slide.src;
      this.paintCheckout();
      this.openDialog(this.added);
      const look = this.added.querySelector('[data-ayo-pdp-look]');
      if (!look || look.dataset.loaded) return;
      look.dataset.loaded = '1';
      const base = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
      for (const intent of ['complementary', 'related']) {
        try {
          const res = await fetch(`${base}?product_id=${this.dataset.productId}&limit=8&intent=${intent}&section_id=ayo-cart-upsell`);
          if (!res.ok) continue;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const cards = doc.querySelector('.ayo-cart__upsell-cards');
          if (cards && cards.children.length) {
            look.querySelector('[data-ayo-pdp-look-list]').replaceChildren(cards);
            look.hidden = false;
            return;
          }
        } catch (e) { /* try the next one */ }
      }
    }

    async paintCheckout() {
      const a = this.added && this.added.querySelector('[data-ayo-pdp-checkout]');
      if (!a) return;
      try {
        const cart = await (await fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`)).json();
        const tpl = cart.item_count === 1 && this.t.itemOne ? this.t.itemOne : this.t.items;
        a.textContent = `${this.t.checkout} ${fill(tpl, { count: cart.item_count })}`.trim();
      } catch (e) { a.textContent = this.t.checkout; }
    }

    async quickAdd(btn) {
      if (btn.classList.contains('is-added') || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const cart = document.querySelector('cart-drawer');
      const fd = new FormData();
      fd.append('id', btn.dataset.variantId);
      fd.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((x) => x.id));
        fd.append('sections_url', window.location.pathname);
      }
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const data = await res.json();
        if (data.status) throw new Error(data.description || '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-product-look', productVariantId: btn.dataset.variantId, cartData: data });
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        btn.classList.add('is-added');
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
        this.refreshCart(cart, data);
        this.paintCheckout();
      } catch (e) { /* leave the button as it was */ } finally {
        btn.classList.remove('is-loading');
      }
    }

    openDialog(dlg) {
      if (!dlg || typeof dlg.showModal !== 'function') return;
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('ayo-lock');
    }

    /* ---------- gallery ---------- */
    setupGallery() {
      this.gallery = this.querySelector('[data-ayo-pdp-gallery]');
      if (!this.gallery) return;
      this.look = this.dataset.gallery || 'peek';
      this.slides = Array.from(this.gallery.children);
      this.dots = Array.from(this.querySelectorAll('.ayo-pdp__dot'));
      this.thumbs = Array.from(this.querySelectorAll('[data-ayo-pdp-thumb]'));
      this.count = this.querySelector('[data-ayo-pdp-count]');
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.ayoPdpThumb, 10))));
      let raf = 0;
      this.gallery.addEventListener('scroll', () => {
        if (raf || this.look === 'grid') return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const step = this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : 1;
          const i = Math.round(Math.abs(this.gallery.scrollLeft) / (Math.abs(step) || 1));
          this.mark(Math.max(0, Math.min(this.slides.length - 1, i)));
        });
      }, { passive: true });
    }

    mark(i) {
      if (i === this.cur) return;
      this.cur = i;
      this.slides.forEach((sl, k) => sl.classList.toggle('is-on', k === i));
      this.dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      this.thumbs.forEach((t, k) => {
        const on = k === i;
        t.classList.toggle('is-on', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (this.count) this.count.textContent = `${i + 1} / ${this.slides.length}`;
      const t = this.thumbs[i];
      if (t && this.look === 'thumbs') {
        const strip = t.parentElement;
        const left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    goTo(i) {
      const slide = this.slides[i];
      if (!slide) return;
      if (this.look === 'grid') { this.mark(i); return; }
      const desktopGrid = window.matchMedia('(min-width: 990px)').matches && ['peek', 'full', 'stack'].includes(this.look);
      if (desktopGrid) {
        if (slide !== this.gallery.firstElementChild) { this.gallery.prepend(slide); this.slides = Array.from(this.gallery.children); }
        return;
      }
      if (this.look === 'stack') { slide.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rtl = getComputedStyle(this.gallery).direction === 'rtl';
      const left = slide.offsetLeft - this.gallery.firstElementChild.offsetLeft;
      this.gallery.scrollTo({ left: rtl ? -Math.abs(left) : left, behavior: reduce ? 'auto' : 'smooth' });
      this.mark(i);
    }

    showColorMedia(value) {
      if (!this.gallery) return;
      const v = this.d.variants.find((x) => x.options[this.colorIdx] === value && x.media);
      if (!v) return;
      const i = this.slides.findIndex((sl) => sl.dataset.mediaId === String(v.media));
      if (i < 0) return;
      if (this.look === 'stack' && !window.matchMedia('(min-width: 990px)').matches) return;
      this.goTo(i);
    }

    showTab(tab) {
      const wrap = tab.closest('[data-ayo-pdp-tabs]');
      wrap.querySelectorAll('.ayo-pdp__tab').forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }

    /* ---------- bottom bar ---------- */
    setupBar() {
      if (!this.bar || !this.addBtn) return;
      let raf = 0;
      let shown = null;
      const check = () => {
        raf = 0;
        // show once the Add to bag button has scrolled up out of view
        const show = this.addBtn.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        this.bar.classList.toggle('is-on', show);
        this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.bar.querySelector('[data-ayo-pdp-bar-btn]').tabIndex = show ? 0 : -1;
        document.body.classList.toggle('modal__sticky-cart', show);
      };
      this.onScroll = () => { if (!raf) raf = requestAnimationFrame(check); };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      check();
    }

    paintBar(v, ref) {
      if (!this.bar) return;
      const price = this.bar.querySelector('[data-ayo-pdp-bar-price]');
      if (price) price.textContent = moneyFmt(ref.price, this.d.money);
      const sub = this.bar.querySelector('[data-ayo-pdp-bar-sub]');
      const btn = this.bar.querySelector('[data-ayo-pdp-bar-btn]');
      this.bar.classList.toggle('is-done', this.inBag);
      if (this.inBag) { sub.textContent = this.t.inBag; btn.textContent = this.t.stickyCheckout; return; }
      sub.textContent = v ? v.options.filter((o) => o && o !== 'Default Title').join(' · ') : this.t.stickyPick;
      btn.textContent = v ? this.t.stickyAdd : this.t.stickyPick;
    }

    barTap() {
      if (this.inBag) { window.location.href = `${(window.routes && window.routes.root_url) || '/'}checkout`.replace('//checkout', '/checkout'); return; }
      if (!this.variant()) { this.warn(); return; }
      this.add(this.bar.querySelector('[data-ayo-pdp-bar-btn]'));
    }
  }
  customElements.define('ayo-product', AyoProduct);
})();
